module.exports = __webpack_public_path__ + "static/media/guardian-team-top.129c8f96.webp";